module.exports = __webpack_public_path__ + "img/right0.fb421448.svg";